const AccessDenied = () => import("../views/AccessDenied.vue");

export default [
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: AccessDenied,
  },
];
